'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('station_requirements', {
      url: '/account/stationaccess/station_requirements',
      template: '<station-requirements></station-requirements>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/station_requirements/station_requirements.routes.js